// import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '../store'
import qs from 'qs'
import { setting } from '@/config/config'
import { refresh } from '@/apis/oms/common'


// export default async function streamFetch(options = {}, onStart,onChunk, onComplete, onError) {

//   var token = store.state.userInfo.token;
//   if (!options.headers) options.headers = {}
//   if (token) {
//     options.headers['Authorization'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
//     options.headers['x-tenant-id'] = store.state.userInfo.tenantId
//   }

//   const {
//     method = 'POST',
//     headers = {},
//     body = null,
//     ...restOptions
//   } = options;




//   var tjurl = setting.mockData ? options.mockPath : setting.basePath + options.url;
//   if (options.url.toLowerCase().indexOf('http') == 0 || options.url.toLowerCase().indexOf('https') == 0) {
//     tjurl = (setting.mockData ? setting.mockbasePath : setting.basePath) + tjurl;
//   }
 


//   try {
//     const response = await fetch(tjurl, {
//       method,
//       headers: {
//         'Content-Type': 'application/json',
//         ...headers
//       },
//       body: body ? JSON.stringify(body) : null,
//       ...restOptions
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//     } else { 
//       if (onStart) { 
//         onStart(response);
//       }
//     }

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder('utf-8');

//     while (true) {
//       const { done, value } = await reader.read();
//       if (done) break;

//       // 解码二进制数据块
//       const chunk = decoder.decode(value, { stream: true });
//       // accumulatedText += chunk;

//       // 调用数据块回调（原始文本）
//       const lines = chunk.split('\n');
//       for (const line of lines) {
//         if (line.startsWith('data:')) {
//           const data = line.slice(5);
//           if (data === '[DONE]') break;
//           try { 
//             const parsed = JSON.parse(data);
//             if (onChunk) {
//               onChunk(parsed);
//             }
//           } catch (e) {
//             console.log('错误串：', data);
//           }
          
         
          
//         }
//       }

      

    
//     }

//     // 最终渲染确保全部内容完整显示
//     if (onComplete) {
//       onComplete();
//     }
//   } catch (error) {
//     console.error('Stream fetch error:', error);
//     let code = 0
//     try {
//       code = error.response.data.status
//     } catch (e) {
//       if (error.toString().indexOf('Error: timeout') !== -1) {
//         Notification.error({
//           title: '网络请求超时',
//           duration: 5000
//         })
        
//       }
//     }
//     if (code) {
//       //令牌过期刷新令牌后重新执行
//       if (code === 401) {
//         refresh(store.state.userInfo.refreshToken).then(data => { 
//           store.dispatch('update_token', data).then(() => {
//             if (data.tenants && data.tenants.length > 0) {
//               store.dispatch('update_tenant', data.tenants[0]).then(() => {
//                 const originalRequest = error.config;
//                 return streamFetch(url, options, onChunk, onComplete, onError)
//               })
//             }
//           })
          
//         })
//       } else if (code === 403) {
//         this.$router.push({ path: '/401' });
//       } else {
//         const errorMsg = error.response.data.message
//         if (errorMsg !== undefined) {
//           Message.error({
//             message: errorMsg,
//             duration: 5000
//           })
//         }
//       }
//     } else {
//       Message.error({
//         message: '接口请求失败',
//         duration: 5000
//       })
//     }

//     if (onError) {
//       onError(error);
//     }
//   }
// }


export default async function streamFetch(options = {}, onStart, onChunk, onComplete, onError) {

  const controller = new AbortController();
  
  var token = store.state.userInfo.token;
  if (!options.headers) options.headers = {}
  if (token) {
    options.headers['Authorization'] = token
    options.headers['x-tenant-id'] = store.state.userInfo.tenantId
  }

  const {
    method = 'POST',
    headers = {},
    body = null,
    ...restOptions
  } = options;

  var tjurl = setting.mockData ? options.mockPath : setting.basePath + options.url;
  if (options.url.toLowerCase().indexOf('http') == 0 || options.url.toLowerCase().indexOf('https') == 0) {
    tjurl = (setting.mockData ? setting.mockbasePath : setting.basePath) + tjurl;
  }

  try {
    const response = await fetch(tjurl, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      body: body ? JSON.stringify(body) : null,
      ...restOptions,
      controller,
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    // else {
    //   if (onStart) {
    //     onStart(response, controller);
    //   }
    // }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';  // 维护缓冲区，存储不完整的行
    let retryNeeded = false;// 标记是否需要重试（因 token 过期）
    let firstRead = false; //第一次读取
    while (true) {
      // 如果已经主动取消，则退出循环
      if (controller.aborted) {
        await reader.cancel();   // 可选：取消读取
        break;
      }

      const { done, value } = await reader.read();
      if (done) break;


      // 解码并将新数据追加到缓冲区
      const valStr = decoder.decode(value, { stream: true });
      buffer += valStr;

      //如果是第一次读取信息，并且有"code":100202字串表示可能令牌过期
      if (valStr.indexOf('"code":100202') > -1 && !firstRead) { 
        try {
          const jsonVal = JSON.parse(valStr);
          if (jsonVal.code == '100202') { 
            retryNeeded = true;
            break;
          }
        } catch (e) { }
      }


      //接口开始读取数据回调
      if (!firstRead) {
        firstRead = true;
        if (onStart) {
          onStart(response, controller);
        }
        
      }
      

      // 按行分割，保留最后一个可能不完整的行
      const lines = buffer.split('\n');
      // 最后一行可能不完整，放回缓冲区
      buffer = lines.pop() || '';

      for (const line of lines) {
        // 处理 data: 开头的行
        if (line.startsWith('data:')) {
          const dataContent = line.slice(5).trim();  // 去掉 'data:' 和首尾空格

          if (dataContent === '[DONE]') {
            // 遇到结束标记，可以提前退出或继续
            if (onComplete) onComplete();
            return;
          }

          try {
            const parsed = JSON.parse(dataContent);
            if (onChunk) {
              onChunk(parsed);
            }
          } catch (e) {
            console.error('JSON解析错误:', dataContent, e);
          }
        }
      }
    }

    //如果需要重试，刷新 token 并重新发起请求
    if (retryNeeded) { 
      const refreshData = await refresh(store.state.userInfo.refreshToken);
      await store.dispatch('update_token', refreshData);
      return streamFetch(options, onStart, onChunk, onComplete, onError)
    }

    // 处理缓冲区中剩余的数据（最后可能还有不完整的一行）
    if (buffer.trim()) {
      if (buffer.startsWith('data:')) {
        const dataContent = buffer.slice(5).trim();
        if (dataContent !== '[DONE]') {
          try {
            const parsed = JSON.parse(dataContent);
            if (onChunk) onChunk(parsed);
          } catch (e) {
            console.error('最终缓冲区解析错误:', buffer, e);
          }
        }
      }
    }

    if (onComplete) {
      onComplete();
    }
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('Stream fetch error:', error);
      // ... 原有的错误处理逻辑保持不变
      let code = 0
      try {
        code = error.response?.data?.status
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
          Notification.error({
            title: '网络请求超时',
            duration: 5000
          })
        }
      }
      if (code) {
        if (code === 401) {
          refresh(store.state.userInfo.refreshToken).then(data => {
            store.dispatch('update_token', data).then(() => {
              if (data.tenants && data.tenants.length > 0) {
                store.dispatch('update_tenant', data.tenants[0]).then(() => {
                  // 注意：这里递归调用需要修正参数
                  return streamFetch(options, onStart, onChunk, onComplete, onError)
                })
              }
            })
          })
        } else if (code === 403) {
          // this.$router 在非 Vue 组件中可能不可用，需要从外部传入或使用 router 实例
          console.warn('403 权限不足')
        } else {
          const errorMsg = error.response?.data?.message
          if (errorMsg) {
            Message.error({
              message: errorMsg,
              duration: 5000
            })
          }
        }
      } else {
        Message.error({
          message: '服务器繁忙，请稍后再试',
          duration: 5000
        })
      }

      if (onError) {
        onError(error);
      }
    }
  }

}